export default function UIIntro() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#EAF5E1] text-[#7FBF3F] text-xs font-semibold px-4 py-2 rounded-full mb-5">
              <i className="ri-leaf-line"></i>About Urban Infra
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#212121] mb-5 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Trusted Real Estate Developer in Bengaluru
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              URBAN INFRA is a trusted real estate developer in Bengaluru delivering eco-friendly residential layouts with modern amenities, prime locations, and long-term investment value. We specialize in villa plots and gated community layouts on Sarjapur Road — one of Bengaluru's fastest-growing corridors.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              Our projects are thoughtfully planned with clear titles, modern infrastructure, and nature-friendly environments — making them ideal for families, end-users, and investors seeking affordable villa plots in Bangalore.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="https://wa.me/919945124133" target="_blank" rel="nofollow noreferrer" className="inline-flex items-center justify-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white font-semibold px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-whatsapp-line"></i>Talk to Our Team
              </a>
              <a href="tel:+919945124133" className="inline-flex items-center justify-center gap-2 border-2 border-[#7FBF3F] text-[#7FBF3F] hover:bg-[#EAF5E1] font-semibold px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-phone-line"></i>Call Now
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {[
              { icon: "ri-leaf-line", title: "Eco-Friendly", desc: "Nature-inspired layouts with green open spaces" },
              { icon: "ri-shield-check-line", title: "Documentation", desc: "Legally verified plots with transparent documentation" },
              { icon: "ri-map-pin-2-line", title: "Prime Location", desc: "On Sarjapur Road, Bengaluru" },
              { icon: "ri-home-heart-line", title: "Modern Amenities", desc: "Gated community with all essential infrastructure" },
            ].map((item) => (
              <div key={item.title} className="bg-[#EAF5E1] rounded-xl p-5 hover:border-[#7FBF3F]/30 border border-[#7FBF3F]/10 transition-all duration-300">
                <div className="w-10 h-10 flex items-center justify-center bg-[#1B2A4A] rounded-lg mb-3">
                  <i className={`${item.icon} text-white text-lg`}></i>
                </div>
                <h3 className="font-semibold text-[#212121] text-sm mb-1">{item.title}</h3>
                <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
